module.exports = __webpack_public_path__ + "img/hanhuadanbao.dcaf4763.png";